import React from 'react';
import PropTypes from 'prop-types';
import RadioButton from '@components/radio-button';
import Button from '@components/button';
import Textarea from '@components/inputs/textarea/component';
import Select from '@components/select';
import Calendar from '@components/calendar/component';
import Checkbox from '@components/checkbox';

import styles from './styles.module.scss';
const {
  details_container,
  date_container,
  time_container,
  header,
  disclaimer,
  availability_container,
  information_container,
  button_container,
  confirm_container,
  checkboxes_container,
  error_message
} = styles;

const StepOne = (props) => {
  let {
    nextStepCallback,
    currentStep,
    onChange,
    availability,
    date,
    dateCallback,
    setTime,
    time,
    setDetails,
    details,
    selected,
    setSelected,
    checkboxError,
    checkboxErrorCallback,
    dateErrorCallback,
    dateError
  } = props;

  const checkIsWeekend = () => {
    var today = new Date();
    if (today.getDay() == 6 || today.getDay() == 0) {
      return 'Next';
    } else {
      return 'This';
    }
  };

  const createTimesArray = () => {
    var halfHours = ['00', '30'];
    var times = [];
    for (var i = 7; i < 13; i++) {
      for (var j = 0; j < 2; j++) {
        var t = i + ':' + halfHours[j];
        if (i < 10) {
          t = '0' + t;
        }
        if (i == 12) {
          t = t + ' PM';
        } else {
          t = t + ' AM';
        }
        times.push({ label: t, value: t });
      }
    }

    for (var k = 1; k < 8; k++) {
      for (var l = 0; l < 2; l++) {
        var ti = k + ':' + halfHours[l];
        if (k < 10) {
          ti = '0' + ti;
        }

        ti = ti + ' PM';
        times.push({ label: ti, value: ti });
      }
    }

    return times;
  };

  // -------------------------------------------------------

  const isWeekend = checkIsWeekend();
  const times = createTimesArray();
  const twoWeeks = 12096e5;

  // -------------------------------------------------------

  const nextStepClick = () => {
    if (currentStep !== 1) return;
    selected.length == 0 && checkboxErrorCallback(true);

    if (availability === 'Next Available' || availability === `${isWeekend} Weekend`) {
      if (selected.length !== 0) {
        nextStepCallback(2);
      }
    }

    if (availability === 'Specific Date/Time' && date && time) {
      if (date === 'false') {
        dateErrorCallback(true);
      }
      if (selected.length !== 0 && date !== 'false') {
        nextStepCallback(2);
      }
    }
  };

  const getNextButton = () => {
    return <Button onClick={() => nextStepClick()} label="Next"></Button>;
  };

  return (
    <>
      <div>
        <div className={header}>
          <h2>Request a Tour</h2>
          <p>When would you like to see this property?</p>
          <span className={disclaimer}>
            Availability depends on many factors, including the seller's schedule. Your agent will
            confirm your appointment time with you directly.
          </span>
        </div>
        <div className={availability_container}>
          <RadioButton
            items={[
              {
                label: 'Next Available',
                value: 'Next Available'
              },
              {
                label: `${isWeekend} Weekend`,
                value: `${isWeekend} Weekend`
              },
              {
                label: 'Specific Date/Time',
                value: 'Specific Date/Time'
              }
            ]}
            selection={availability}
            theme="with-label-inside-square"
            groupName="availabilty"
            center={true}
            onChange={onChange}
          ></RadioButton>
        </div>
        <div className={information_container}>
          {availability === 'Next Available' || availability === `${isWeekend} Weekend` ? (
            <div className={details_container}>
              <p>Let us know what works for you</p>
              <Textarea
                placeholder="Example: Any time after noon works for me."
                rows="5"
                inputValueCallback={(text) => setDetails(text)}
                defaultInputValue={details}
              />
            </div>
          ) : (
            <>
              <div className={date_container}>
                <p>Date</p>
                <Calendar
                  dateCallback={dateCallback}
                  date={date}
                  startDate={new Date()}
                  endDate={+new Date() + twoWeeks}
                />
                {dateError && <p className={error_message}>Please select a date for your tour.</p>}
              </div>
              <div className={time_container}>
                <p>Time</p>
                <Select onChange={setTime} options={times} selected={time} />
              </div>
            </>
          )}
        </div>
        <div className={confirm_container}>
          <div className={checkboxes_container}>
            <p>How should we confirm a time with you?</p>
            <Checkbox
              items={[
                { label: 'Call', value: 'Call' },
                { label: 'Text', value: 'Text' },
                { label: 'Email', value: 'Email' }
              ]}
              selections={selected}
              onChange={setSelected}
              selectAllLabel={null}
              layout={'row'}
            />
            {checkboxError && <p className={error_message}>Please select a contact option.</p>}
          </div>
          <div className={button_container}>{getNextButton()}</div>
        </div>
      </div>
    </>
  );
};

StepOne.propTypes = {
  /**
   * Specifies the users avaiability to see the listing
   */
  availability: PropTypes.string,

  /**
   * Specifies whether to show the checkbox error
   */
  checkboxError: PropTypes.bool,

  /**
   * Function to set the checkbox error state
   */
  checkboxErrorCallback: PropTypes.func,

  /**
   * Specifies what step the modal is on
   */
  currentStep: PropTypes.string,

  /**
   * Specifies what date the user would like to view the listing
   */
  date: PropTypes.string,

  /**
   * Callback func that sets the date
   */
  dateCallback: PropTypes.func,

  /**
   * Specifies whether to show the date input error message
   */
  dateError: PropTypes.bool,

  /**
   * Function to set the date error state
   */
  dateErrorCallback: PropTypes.func,

  /**
   * Specifies any details the user has about viewing the listing
   */
  details: PropTypes.string,

  /**
   * Callback func that tracks the next step click
   */
  nextStepCallback: PropTypes.func,

  /**
   * Callback func that tracks items isChecked
   */
  onChange: PropTypes.func,

  /**
   * Specifies what contact options are checked
   */
  selected: PropTypes.array,

  /**
   * Sets the user specified details
   */
  setDetails: PropTypes.func,

  /**
   * Callback func that tracks items checked
   */
  setSelected: PropTypes.func,

  /**
   * Sets the user's specified time
   */
  setTime: PropTypes.func,

  /**
   * Specifies whether to show the details textarea error
   */
  textareaError: PropTypes.bool,

  /**
   * Function to set the textarea error state
   */
  textareaErrorCallback: PropTypes.func,

  /**
   * Specifies the user's choosen time
   */
  time: PropTypes.string
};

export default StepOne;
